import React from 'react';
var AirtableIcon = function AirtableIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-635.5",
    y: "-268.5",
    width: "1941",
    height: "891",
    rx: "4.5",
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "6",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.375",
    y: "0.375",
    width: "23.25",
    height: "23.25",
    rx: "5.625",
    stroke: "#0B1228",
    strokeOpacity: "0.14",
    strokeWidth: "0.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
    fill: "#26B5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
    fill: "#ED3049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
    fill: "black",
    fillOpacity: "0.25"
  }));
};
export default AirtableIcon;